
import React from 'react';
import ImageRecord1 from './ImageRecord3';
import ImageRecord2 from './ImageRecord1';
import ImageRecord3 from './ImageRecord2';


const IndexRecord = (props) => {
    if(props.name === 1){
        return <ImageRecord1/>
    }else if(props.name === 2){
        return <ImageRecord2/>
    }else{
        return <ImageRecord3/>
    }
}

export default IndexRecord;